/* eslint no-console: ["error", { allow: ["error", "info"] }] */

import Utils from './Utils';

class EnquiryForm {
    constructor() {
        this.selectBoxSelector = '#nf-field-5';
        this.nextBtnSelector = '.nf-next-item input';

        this.resortSelector = '#nf-field-11-wrap';
        this.infoboxResortSelector = '#nf-field-51-wrap';
        this.yachtSelector = '#nf-field-13-wrap';
        this.infoboxYachtSelector = '#nf-field-52-wrap';

        // defaults selected in NinjaForms
        // this.lastResortInfoboxItemIndex = 0;
        // this.lastYachtInfoboxItemIndex = 0;

        // mapping which radio btn ID should reveal which infobox
        this.resortRadioBtnInfoboxMapping = {
            0: '#enq-palm',
            1: '#enq-ocean',
            2: '#enq-1bd-turtle',
            3: '#enq-2bd-turtle',
            4: '#enq-1bd-villa',
            5: '#enq-2bd-pool-villa',
        };

        // mapping which radio btn ID should reveal which infobox
        this.yachtRadioBtnInfoboxMapping = {
            0: '#enq-deluxe-cab',
            1: '#enq-standard-cab',
            2: '#enq-master-cab',
            3: '#enq-superlux-cab',
        };

        const form = document.querySelector('#nf-form-2-cont');

        if (Utils.isUndefined(form)) {
            console.error('Form could not be loaded');
            return;
        }

        this.init();
    }

    init = async () => {
        this.selectBox = document.querySelector(this.selectBoxSelector);
        this.nextBtn = document.querySelector(this.nextBtnSelector);

        this.resortGroup = undefined;
        this.yachtGroup = undefined;

        this.resortGroupRadioButtons = undefined;
        this.yachtGroupRadioButtons = undefined;

        if (Utils.isUndefined(this.selectBox)) {
            // wait until the current page is active again
            this.waitUntilPageIsVisible().then(() => {
                this.init();
            });

            return;
        }

        this.nextBtn.addEventListener('click', () => {
            setTimeout(() => {
                const selectBox = document.querySelector(this.selectBoxSelector);

                // if we are on the next page, wait until we face the first tab again
                if (Utils.isUndefined(selectBox)) {
                    this.init();
                }
            }, 100);
        });

        this.setActiveElements();
        this.reattachEventListeners();

        this.selectBox.addEventListener('change', async (evt) => {
            const selectBoxOptions = evt.target.options;
            const waitFor = this.collectInputFieldsToWaitFor(selectBoxOptions);

            await this.waitUntilElementsAreLoaded(waitFor);

            // close all infobox panels when selecting another option
            ['#resort-stay-info', '#dive-yacht-info'].forEach((selector) => {
                document.querySelector(selector)?.classList.remove('show');
            });
            this.setActiveElements();
            this.reattachEventListeners();
            this.reorderAccommodations(selectBoxOptions);
        });
    };

    collectInputFieldsToWaitFor = (selectBoxOptions) => {
        const waitFor = new Set();
        Array.from(selectBoxOptions).forEach((option) => {
            if (!option.selected) return;

            if ('Resort Pelagian Combo' === option.value || 'Pelagian Resort Combo' === option.value) {
                waitFor.add(this.resortSelector);
                waitFor.add(this.yachtSelector);
            } else if ('Resort' === option.value) {
                waitFor.add(this.resortSelector);
                waitFor.delete(this.yachtSelector);
            } else if ('Pelagian' === option.value) {
                waitFor.add(this.yachtSelector);
                waitFor.delete(this.resortSelector);
            }
        });

        return waitFor;
    };

    setActiveElements = () => {
        const resortGroup = document.querySelector(this.resortSelector);
        const yachtGroup = document.querySelector(this.yachtSelector);

        this.resortGroup = resortGroup ?? undefined;
        this.yachtGroup = yachtGroup ?? undefined;

        this.resortGroupRadioButtons = Utils.isUndefined(resortGroup)
            ? undefined
            : resortGroup.querySelectorAll('input');

        // get initial selected index of radio button
        if (!Utils.isUndefined(this.resortGroupRadioButtons) && Utils.isUndefined(this.lastResortInfoboxItemIndex)) {
            Array.from(this.resortGroupRadioButtons).forEach((radioBtn, index) => {
                if (radioBtn.checked) {
                    this.lastResortInfoboxItemIndex = index;
                    return;
                }
            });
        }

        this.yachtGroupRadioButtons = Utils.isUndefined(yachtGroup) ? undefined : yachtGroup.querySelectorAll('input');

        // get initial selected index of radio button
        if (!Utils.isUndefined(this.yachtGroupRadioButtons) && Utils.isUndefined(this.lastYachtInfoboxItemIndex)) {
            Array.from(this.yachtGroupRadioButtons).forEach((radioBtn, index) => {
                if (radioBtn.checked) {
                    this.lastYachtInfoboxItemIndex = index;
                    return;
                }
            });
        }
    };

    reattachEventListeners = () => {
        if (!Utils.isUndefined(this.resortGroupRadioButtons)) {
            Array.from(this.resortGroupRadioButtons).forEach((radioBtn) => {
                radioBtn.addEventListener('change', this.radioButtonOnChange);
            });

            // set to the last selected infobox item when changing the selectbox
            if (!Utils.isUndefined(this.lastResortInfoboxItemIndex)) {
                this.resortGroupRadioButtons[this.lastResortInfoboxItemIndex].dispatchEvent(
                    new Event('change', { bubbles: true }),
                );
            }
        }

        if (!Utils.isUndefined(this.yachtGroupRadioButtons)) {
            Array.from(this.yachtGroupRadioButtons).forEach((radioBtn) => {
                radioBtn.addEventListener('change', this.radioButtonOnChange);
            });

            if (!Utils.isUndefined(this.lastYachtInfoboxItemIndex)) {
                // set to the last selected infobox item when changing the selectbox
                this.yachtGroupRadioButtons[this.lastYachtInfoboxItemIndex].dispatchEvent(
                    new Event('change', { bubbles: true }),
                );
            }
        }
    };

    reorderAccommodations = (selectBoxOptions) => {
        const srcParent = document.querySelector(this.resortSelector.replace('wrap', 'container'))?.parentElement;
        const srcInfoParent = document.querySelector(
            this.infoboxResortSelector.replace('wrap', 'container'),
        )?.parentElement;
        const targetParent = document.querySelector(this.yachtSelector.replace('wrap', 'container'))?.parentElement;
        const targetInfoParent = document.querySelector(
            this.infoboxYachtSelector.replace('wrap', 'container'),
        )?.parentElement;
        Array.from(selectBoxOptions).forEach((option) => {
            if (!option.selected) return;

            if ('Resort Pelagian Combo' === option.value) {
                targetParent.before(srcInfoParent);
                srcInfoParent.before(srcParent);
            } else if ('Pelagian Resort Combo' === option.value) {
                targetInfoParent.after(srcParent);
                srcParent.after(srcInfoParent);
            }
        });
    };

    // resort or yacht mappings
    hideAllInfoboxItems = (infoboxItems) => {
        for (const itemId of Object.values(infoboxItems)) {
            if (itemId === '') {
                continue;
            }

            const infobox = document.querySelector(itemId);

            if (Utils.isUndefined(infobox)) {
                continue;
            }

            infobox.classList.add('d-none');
        }
    };

    isResortGroup = (element) => {
        const parent = element.closest(this.resortSelector);

        if (Utils.isUndefined(parent)) {
            return false;
        }

        return true;
    };

    radioButtonOnChange = (evt) => {
        let infoboxMapping;

        let targetId = evt.target.id.split(/nf-field-\d+-/).filter(Boolean);

        targetId = Array.isArray(targetId) ? +targetId[0] : targetId;

        if (this.isResortGroup(evt.target)) {
            infoboxMapping = this.resortRadioBtnInfoboxMapping;
            this.lastResortInfoboxItemIndex = targetId;
        } else {
            infoboxMapping = this.yachtRadioBtnInfoboxMapping;
            this.lastYachtInfoboxItemIndex = targetId;
        }

        // hide other box items inside the box
        this.hideAllInfoboxItems(infoboxMapping);

        const selector = infoboxMapping[targetId];

        if (Utils.isUndefined(selector) || selector === '') {
            return;
        }

        const infobox = document.querySelector(selector);

        if (Utils.isUndefined(infobox)) {
            return;
        }

        infobox.classList.remove('d-none');
    };

    waitUntilElementsAreLoaded = (selectors) => {
        const waitTime = 1000; // 1s
        return Promise.race([
            new Promise((_, reject) => setTimeout(() => reject(), waitTime)),
            new Promise((resolve) => {
                const isLoaded = () => {
                    const elements = [];
                    Array.from(selectors).forEach((selector) => {
                        elements.push(document.querySelector(selector));
                    });

                    return elements.every((element) => !Utils.isUndefined(element) && element.isConnected)
                        ? resolve()
                        : setTimeout(isLoaded, 200);
                };

                isLoaded();
            }),
        ]);
    };

    waitUntilPageIsVisible = () => {
        const waitTime = 5 * 60 * 1000; // 5min
        return Promise.race([
            new Promise((_, reject) => setTimeout(() => reject(), waitTime)),
            new Promise((resolve) => {
                const isLoaded = () => {
                    const resortGroup = document.querySelector(this.resortSelector);
                    return !Utils.isUndefined(resortGroup) ? resolve() : setTimeout(isLoaded, 500);
                };

                isLoaded();
            }),
        ]);
    };
}

export default EnquiryForm;
